import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14ebdc81"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fs-13"
}
const _hoisted_2 = {
  key: 1,
  class: "fs-13"
}
const _hoisted_3 = ["data-bs-content"]
const _hoisted_4 = ["data-bs-content"]
const _hoisted_5 = ["data-bs-content"]
const _hoisted_6 = ["data-bs-content"]
const _hoisted_7 = ["data-bs-content"]
const _hoisted_8 = { key: 7 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge w-100 bg-secondary" }, "Manual Analysis Needed", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.status === 'Passed')
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, " No Predictions: You Passed "))
    : (_ctx.status === 'Invested')
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " No Predictions: You Invested "))
      : (_ctx.customAnswerFails && _ctx.inThesis !== null && _ctx.gapClosingScore !== null)
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass([_ctx.descriptorBadgeClass, "popover-content"]),
            tabindex: "0",
            "data-bs-toggle": "popover",
            "data-bs-html": "true",
            "data-bs-trigger": "hover focus",
            "data-bs-content": _ctx.generateHardFailContent()
          }, " Pass: " + _toDisplayString(_ctx.formattedHardFailReasons), 11, _hoisted_3))
        : (_ctx.hasHardFails && _ctx.inThesis !== null && _ctx.gapClosingScore !== null)
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              class: _normalizeClass([_ctx.descriptorBadgeClass, "popover-content"]),
              tabindex: "0",
              "data-bs-toggle": "popover",
              "data-bs-html": "true",
              "data-bs-trigger": "hover focus",
              "data-bs-content": _ctx.generateHardFailContent()
            }, " Pass: " + _toDisplayString(_ctx.formattedHardFailReasons), 11, _hoisted_4))
          : (_ctx.gapClosingScore < 6 && _ctx.inThesis !== null && _ctx.gapClosingScore !== null)
            ? (_openBlock(), _createElementBlock("span", {
                key: 4,
                class: _normalizeClass([_ctx.descriptorBadgeClass, "popover-content"]),
                tabindex: "0",
                "data-bs-toggle": "popover",
                "data-bs-html": "true",
                "data-bs-trigger": "hover focus",
                "data-bs-content": _ctx.generateHardFailContent()
              }, " Pass: " + _toDisplayString(_ctx.formattedHardFailReasons), 11, _hoisted_5))
            : ((_ctx.gapClosingScore >= 6 && _ctx.gapClosingScore < 7) && _ctx.inThesis !== null && _ctx.gapClosingScore !== null)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 5,
                  class: _normalizeClass([_ctx.descriptorBadgeClass, "popover-content"]),
                  tabindex: "0",
                  "data-bs-toggle": "popover",
                  "data-bs-html": "true",
                  "data-bs-trigger": "hover focus",
                  "data-bs-content": _ctx.generateHardFailContent()
                }, [
                  _createTextVNode(" Research: "),
                  (_ctx.softPassReasons.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.formattedSoftPassReasons), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Impact ")
                      ], 64))
                ], 10, _hoisted_6))
              : (_ctx.gapClosingScore !== null)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 6,
                    class: _normalizeClass([_ctx.descriptorBadgeClass, "popover-content"]),
                    tabindex: "0",
                    "data-bs-toggle": "popover",
                    "data-bs-html": "true",
                    "data-bs-trigger": "hover focus",
                    "data-bs-content": _ctx.generateHardFailContent()
                  }, [
                    (_ctx.softPassReasons.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" Research: " + _toDisplayString(_ctx.formattedSoftPassReasons), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Confirm: Impact ")
                        ], 64))
                  ], 10, _hoisted_7))
                : (_ctx.gapClosingScore === null && _ctx.hasActiveFailures === true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_10))
                  : _createCommentVNode("", true)
}